import { gql } from 'graphql-request'

export const usuariosByGruposUsuariosPagedQueryGql = gql`
  query UsuariosByGruposUsuariosPagedQuery(
    $filterInput: UsuariosByGruposUsuariosFilterInput
  ) {
    usuariosByGruposUsuariosPaged(filterInput: $filterInput) {
      content {
        id
        nome
        email
      }
      totalElements
    }
  }
`
